import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useUsers() {
  const createUser = async (body, registrationId) => {
    const _body = compress(JSON.stringify(body));

    let token = {};

    if (registrationId) token["x-registration-id"] = registrationId;
    if (!registrationId)
      token.Authorization = `Bearer ${localStorage.getItem("token")}`;

    const result = await axios.post(`${apiUri}/api/v1/users`, _body, {
      headers: {
        "Content-Type": "text/plain",
        ...token,
      },
    });

    return result.data;
  };

  const patchUser = async (userId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/users/${userId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const createUserExternal = async (body, externalType) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/users/external`, _body, {
      headers: {
        "Content-Type": "text/plain",
        "x-external-type": externalType,
      },
    });

    return result.data;
  };

  const getUser = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/users/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data.data;
  };

  const getUserRating = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/users/${id}/ratings`);
    return result.data.data;
  };

  const queryUserRatings = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/users/ratings/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const queryUsers = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/users/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const uploadAvatar = async (userId, file, registrationId = undefined) => {
    let data = new FormData();
    data.append("file", file, "profile");

    const headers = {};

    if (registrationId) {
      headers["x-registration-id"] = registrationId;
    }

    if (!registrationId) {
      headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    }

    const result = await axios.patch(
      `${apiUri}/api/v1/users/${userId}/avatar`,
      data,
      {
        maxBodyLength: Infinity,
        headers,
      }
    );

    return result.data.data;
  };

  const uploadBanner = async (userId, file) => {
    let data = new FormData();
    data.append("file", file, "banner");

    const result = await axios.patch(
      `${apiUri}/api/v1/users/${userId}/banner`,
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const queryPlans = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/plans/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
      },
    });

    return result.data;
  };

  const getPlan = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/plans/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data.data;
  };

  const queryDesignWorks = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/designWorkTypes/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };

  const queryDesignSpaces = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/designSpaceTypes/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };

  const queryDesignStyles = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/designStyleTypes/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };

  const queryWorkExchanges = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/workExchangeTypes/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };

  const queryFaqCategories = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/faqCategories/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };
  const queryFaqs = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/faqs/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
      },
    });

    return result.data;
  };

  const queryFaqSubCategories = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/faqSubCategories/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };

  const queryStaffs = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/staffs/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const queryStaffRatings = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/staffs/chatSessions/ratings/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getStaff = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/staffs/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data.data;
  };

  const createStaff = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/staffs`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data?.data;
  };

  const patchStaff = async (staffId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/staffs/${staffId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const deleteStaff = async (staffId) => {
    const result = await axios.delete(`${apiUri}/api/v1/staffs/${staffId}`, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const uploadStaffAvatar = async (staffId, file) => {
    let data = new FormData();
    data.append("file", file, "profile");

    const result = await axios.patch(
      `${apiUri}/api/v1/staffs/${staffId}/avatar/upload`,
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const rejectUser = async (userId, reason) => {
    const _body = compress(
      JSON.stringify({
        reason,
      })
    );

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/rejections`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getUserRejections = async (userId) => {
    const result = await axios.get(
      `${apiUri}/api/v1/users/${userId}/rejections`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const uploadCertificate = async (userId, certId, file) => {
    const _body = compress(JSON.stringify(file));

    const result = await axios.patch(
      `${apiUri}/api/v1/users/${userId}/certificates/${certId}/upload`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data?.data;
  };

  const queryCompanies = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/companies/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const getCompany = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/companies/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data.data;
  };

  const createCompany = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/companies`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data?.data;
  };

  const patchCompany = async (companyId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/companies/${companyId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const uploadCompanyLogo = async (companyId, file) => {
    let data = new FormData();
    data.append("file", file, "profile");

    const result = await axios.patch(
      `${apiUri}/api/v1/companies/${companyId}/logo/upload`,
      data,
      {
        maxBodyLength: Infinity,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const querySubscriptions = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/subscriptions/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const createSubscription = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/subscriptions`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data?.data;
  };

  const patchSubscription = async (_id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/subscriptions/${_id}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const getUserPermissions = async (userId) => {
    const {
      data: { data },
    } = await axios.get(`${apiUri}/api/v1/users/${userId}/permissions`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return data;
  };

  const queryRoles = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/roles/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const queryItems = async (userId, filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/cartItems/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data;
  };

  const addItem = async (userId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/cartItems`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data;
  };

  const patchQty = async (userId, workId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/users/${userId}/cartItems/${workId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data;
  };

  const deleteItem = async (userId, workId) => {
    const result = await axios.delete(
      `${apiUri}/api/v1/users/${userId}/cartItems/${workId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return result.data?.data;
  };

  const deleteItemsAll = async (userId) => {
    const result = await axios.delete(
      `${apiUri}/api/v1/users/${userId}/cartItems`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return result.data?.data;
  };

  const getStatistics = async (userId) => {
    const {
      data: { data },
    } = await axios.get(`${apiUri}/api/v1/users/${userId}/statistics`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return data;
  };

  const createRatings = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/users/ratings`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data;
  };

  const patchRating = async (ratingId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/users/ratings/${ratingId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data;
  };

  const queryWorkExchangeModelTypes = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/workExchangeModelTypes/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };

  const queryWorkExchangeMaterialTypes = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/workExchangeMaterialTypes/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };

  const queryWorkExchangeDrawingTypes = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/workExchangeDrawingTypes/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    return result.data;
  };

  const changeStaffPassword = async (userId, password) => {
    const _body = compress(JSON.stringify({ password }));

    const result = await axios.patch(
      `${apiUri}/api/v1/staffs/${userId}/password`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const queryUserChatSessions = async (
    userId,
    filter,
    page,
    limit,
    project,
    sort
  ) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/chatSessions/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const queryStaffChatSessions = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/staffs/chatSessions/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const transferWorkToCompany = async (userId, companyId) => {
    const _body = compress(
      JSON.stringify({
        company: companyId,
      })
    );

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/works/transfer`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const transferCertificateToCompany = async (userId, companyId) => {
    const _body = compress(
      JSON.stringify({
        company: companyId,
      })
    );

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/certificates/transfer`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getPaymentMethod = async (userId) => {
    const result = await axios.get(
      `${apiUri}/api/v1/users/${userId}/paymentMethod`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const patchPaymentMethod = async (userId, cardId) => {
    const _body = compress(
      JSON.stringify({
        cardId,
      })
    );

    const result = await axios.patch(
      `${apiUri}/api/v1/users/${userId}/paymentMethod`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const queryPurchases = async (userId, filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/users/${userId}/purchases/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getUserSummary = async () => {
    const result = await axios.get(`${apiUri}/api/v1/users/summary`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const getCompaniesSummary = async () => {
    const result = await axios.get(`${apiUri}/api/v1/companies/summary`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const getChatSupportSummary = async () => {
    const result = await axios.get(
      `${apiUri}/api/v1/staffs/chatSessions/summary`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  return {
    queryPlans,
    queryUsers,
    createUser,
    createUserExternal,
    getUser,
    queryDesignWorks,
    queryDesignStyles,
    queryDesignSpaces,
    uploadAvatar,
    uploadBanner,
    getPlan,
    queryStaffs,
    getStaff,
    createStaff,
    patchStaff,
    getUserRating,
    patchUser,
    rejectUser,
    getUserRejections,
    queryCompanies,
    createCompany,
    patchCompany,
    uploadStaffAvatar,
    deleteStaff,
    getCompany,
    uploadCompanyLogo,
    querySubscriptions,
    createSubscription,
    patchSubscription,
    queryUserRatings,
    queryWorkExchanges,
    queryRoles,
    getUserPermissions,
    queryItems,
    addItem,
    patchQty,
    deleteItem,
    deleteItemsAll,
    getStatistics,
    createRatings,
    patchRating,
    queryWorkExchangeModelTypes,
    queryWorkExchangeMaterialTypes,
    queryWorkExchangeDrawingTypes,
    changeStaffPassword,
    queryUserChatSessions,
    queryFaqSubCategories,
    queryFaqCategories,
    queryFaqs,
    queryStaffChatSessions,
    transferWorkToCompany,
    transferCertificateToCompany,
    getPaymentMethod,
    patchPaymentMethod,
    queryPurchases,
    getUserSummary,
    getCompaniesSummary,
    queryStaffRatings,
    getChatSupportSummary,
  };
}
